// extracted by mini-css-extract-plugin
module.exports = {"paymentImgBox":"PaymentMethod_paymentImgBox__1GHP8"};